import React from 'react';
import * as styles from './caption.module.scss';

interface ICaptionProps {
  caption: string;
}

/**
 * need to be wrapped into a div with position egal to relative
 *
 * @param param0
 * @returns
 */
export const Caption = ({ caption }: ICaptionProps) => <p className={styles.caption}>{caption}</p>;
